export default __webpack_public_path__ + "static/media/Quiz-Score-Icons.6779e868.png";